import { render, staticRenderFns } from "./RoomBase.vue?vue&type=template&id=638e8f2e&"
import script from "./RoomBase.vue?vue&type=script&lang=js&"
export * from "./RoomBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports